import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useForm } from 'react-hook-form';
import { Layout } from '../../components/layout/Layout';
import { PageHeader } from '../../components/layout/PageHeader';
import { Card, CardContent, CardHeader, CardTitle } from '../../components/ui/Card';
import { Button } from '../../components/ui/Button';
import { Textarea } from '../../components/ui/Textarea';
import { completeTeacherProfile } from '../../modules/platform/api/onboarding';
import { showErrorToast, showSuccessToast } from '../../utils/errorHandler';
import { ROUTES } from '../../utils/constants';

interface TeacherProfileFormData {
  bio: string;
}

export const TeacherProfilePage: React.FC = () => {
  const [isLoading, setIsLoading] = useState(false);
  const navigate = useNavigate();

  const {
    register,
    handleSubmit,
    formState: { errors },
  } = useForm<TeacherProfileFormData>();

  const onSubmit = async (data: TeacherProfileFormData) => {
    setIsLoading(true);
    try {
      await completeTeacherProfile({ bio: data.bio });
      showSuccessToast('Profile completed successfully!');
      navigate(ROUTES.TEACHER_DASHBOARD);
    } catch (error) {
      showErrorToast(error);
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Layout showSidebar={false}>
      <PageHeader
        title="Complete Your Profile"
        subtitle="Tell us about yourself to get started"
      />

      <Card className="max-w-2xl mx-auto">
        <CardHeader>
          <CardTitle>Teacher Profile</CardTitle>
        </CardHeader>
        <CardContent>
          <form onSubmit={handleSubmit(onSubmit)} className="space-y-4">
            <Textarea
              label="Bio"
              {...register('bio', {
                required: 'Bio is required',
                minLength: { value: 50, message: 'Bio must be at least 50 characters' },
              })}
              error={errors.bio?.message}
              placeholder="Tell us about your teaching experience, subjects you teach, and your passion for education..."
              rows={6}
              helperText="Minimum 50 characters"
            />

            <div className="flex gap-4 pt-4">
              <Button type="submit" isLoading={isLoading} className="flex-1">
                Complete Profile
              </Button>
            </div>
          </form>
        </CardContent>
      </Card>
    </Layout>
  );
};

